<script lang="ts">
	import { getCurrentMarketTimeSeriesPoints } from '$lib/data/fundingRate';
	import type { MarketTimeseriesRangeOption } from '$lib/types/market';
	import {
		loadingMarketTimeSeriesPoints,
		marketTimeSeriesPoints,
		marketTimeSeriesRange
	} from '../store';
	export let range: MarketTimeseriesRangeOption;

	function setMarketTimeSeriesRange(range: MarketTimeseriesRangeOption) {
		if ($marketTimeSeriesPoints && !$loadingMarketTimeSeriesPoints) {
			$marketTimeSeriesRange = range;
			getCurrentMarketTimeSeriesPoints();
		}
	}
</script>

<div
	class="px-2 py-1 cursor-pointer hover:bg-fx-grey-700 rounded"
	class:activeChartButton={$marketTimeSeriesRange == range}
	on:click={() => setMarketTimeSeriesRange(range)}
	on:keydown={() => setMarketTimeSeriesRange(range)}
>
	{range}
</div>

<style>
	.activeChartButton {
		@apply text-fx-grey-200 bg-fx-grey-600;
	}
</style>
